import { createRouter, createWebHashHistory } from "vue-router";
import Dashboard from "./components/Dashboard.vue";

const routes = [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true },
    component: Dashboard,
  },
  {
    path: "/educacion",
    name: "educacion",
    meta: { requiresAuth: true },
    component: () => import("./components/EducacionDesempe.vue"),
  },
  {
    path: "/educacion/material",
    name: "educacion-material",
    meta: { requiresAuth: true },
    component: () => import("./components/EducacionMaterial.vue"),
  },
  {
    path: "/gastos/obras",
    name: "obras",
    meta: { requiresAuth: true },
    component: () => import("./components/GastosPresupuesto.vue"),
  },
  {
    path: "/gastos/corrientes",
    name: "corrientes",
    meta: { requiresAuth: true },
    component: () => import("./components/GastosPresupuestoCorrientes.vue"),
  },
  {
    path: "/salud",
    name: "salud",
    meta: { requiresAuth: true },
    component: () => import("./components/SaludIndicadores.vue"),
  },
  {
    path: "/patrimonio",
    name: "patrimonio",
    meta: { requiresAuth: true },
    component: () => import("./components/Inmueble.vue"),
  },
  {
    path: "/saneamiento/saneamiento",
    name: "saneamiento",
    meta: { requiresAuth: true },
    component: () => import("./components/Saneamiento.vue"),
  },
  {
    path: "/abastecimiento/servicios",
    name: "abastecimiento-servicios",
    meta: { requiresAuth: true },
    component: () => import("./components/Abastecimiento.vue"),
  },
  {
    path: "/abastecimiento/bien",
    name: "abastecimiento-bien",
    meta: { requiresAuth: true },
    component: () => import("./components/AbastecimientoBien.vue"),
  },
  {
    path: "/inclusion/ong-paz-esperanza",
    name: "inclusion-ong-paz-esperanza",
    meta: { requiresAuth: true },
    component: () => import("./components/IncOngPaz.vue"),
  },

  /* INCLUSIÓN 
  "/inclusion/cem"
"/inclusion/dre"
"/inclusion/pj"
"/inclusion/mp"
"/inclusion/pnp"
"/inclusion/municipalidades"
"/inclusion/ong-paz-esperanza"

  */
  /* Ready */
  {
    path: "/inclusion/pj",
    name: "inclusion-pj",
    meta: { requiresAuth: true },
    component: () => import("./components/IncPJ.vue"),
  },
  {
    path: "/inclusion/pnp",
    name: "inclusion-pnp",
    meta: { requiresAuth: true },
    component: () => import("./components/IncPNP.vue"),
  },
  {
    path: "/inclusion/municipalidades",
    name: "inclusion-municipalidades",
    meta: { requiresAuth: true },
    component: () => import("./components/IncMuni.vue"),
  },
  {
    path: "/inclusion/dre",
    name: "inclusion-dre",
    meta: { requiresAuth: true },
    component: () => import("./components/IncDre.vue"),
  },
  {
    path: "/inclusion/cem",
    name: "inclusion-cem",
    meta: { requiresAuth: true },
    component: () => import("./components/IncCem.vue"),
  },
  /* FALTAN */

  {
    path: "/inclusion/mp",
    name: "inclusion-mp",
    meta: { requiresAuth: true },
    component: () => import("./components/AbastecimientoBien.vue"),
  },

  /* INCLUSIÓN */

  {
    path: "/login",
    name: "login",
    meta: { requiresAuth: false },
    component: () => import("./pages/Login.vue"),
  },

  {
    path: "/",
    name: "tablero",
    meta: { requiresAuth: false },
    component: () => import("./pages/GridDemo.vue"),
  },
  /* public routes */
  {
    path: "/publico/saneamiento",
    name: "publico-saneamiento",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/SaneamientoPublic.vue"),
  },
  {
    path: "/publico/salud",
    name: "public-salud",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/SaludPublic.vue"),
  },
  {
    path: "/publico/educacion",
    name: "public-educacion",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/EducacionPublic.vue"),
  },
  {
    path: "/publico/presupuesto",
    name: "public-obras",
    meta: { requiresAuth: false },
    component: () => import("./pages/Presupuesto.vue"),
  },
  {
    path: "/publico/inclusion",
    name: "public-inclusion",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/InclusionPublic.vue"),
  },
  {
    path: "/publico/transparencia",
    name: "public-transparencia",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/TransparenciaPublic.vue"),
  },
  {
    path: "/publico/drtc",
    name: "public-drtc",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/Transportes.vue"),
  },
  {
    path: "/publico/desarrollo",
    name: "public-desarrollo",
    meta: { requiresAuth: false },
    component: () => import("./pages/publico/GerenciaDesarrollo.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
